import c from 'classnames';
import React, { PropsWithChildren, useState } from 'react';
import './SubNavigationItem.css';

interface SubNavigationItemProps extends PropsWithChildren<{}> {
    label: string;
}

const SubNavigationItem = ({ label, children }: SubNavigationItemProps) => {
    const [open, setOpen] = useState(false);

    return (
        <li className="HasSubMenu">
            <button
                className={c('NavigationItem SubNavigationToggle', { open })}
                onClick={() => setOpen(!open)}
                aria-expanded={open}
                aria-controls="sub-navigation"
            >
                <span className={c('SubNavigationLabel', { open })}>{label}</span>
            </button>
            <ol id="sub-navigation" className={c('SubNavigation', { open })} hidden={!open}>
                {children}
            </ol>
        </li>
    );
};

export default SubNavigationItem;
